export default __webpack_public_path__ + "static/media/downloadIcon.24b9a153.svg";